import { CalendarEventForm } from "./CalendarEventForm"
import { CalendarEventStore } from "./CalendarEventFormReducer"

function getCalendarEventStore(state): CalendarEventStore {
    return state.calendarEventReducer as CalendarEventStore
}

export function getCalendarEventForm(state): CalendarEventForm {
    return getCalendarEventStore(state).calendarEventForm
}

export function getCalendarEventFormStepIndex(state): number {
    return getCalendarEventStore(state).stepIndex
}




// WEBPACK FOOTER //
// ./src/state/calendar-event/CalendarEventFormSelectors.ts